function getViewportDimensions() {
  return {
    windowWidth: Math.max(
      document.documentElement.clientWidth,
      window.innerWidth || 0
    ),
    windowHeight: Math.max(
      document.documentElement.clientHeight,
      window.innerHeight || 0
    ),
  }
}

export let scaleFactor = 1
let vw = 0
let vh = 0

export function scale(el: HTMLElement, width: number, height: number) {
  const { windowWidth, windowHeight } = getViewportDimensions()
  vw = windowWidth
  vh = windowHeight

  scaleFactor = Math.min(windowWidth / width, windowHeight / height)
  el.style.width = `${width}px`
  el.style.height = `${height}px`
  el.style.transform = `scale(${scaleFactor})`
  el.style.transformOrigin = 'top left'
}

export function initRootScaler(
  elementId: string = 'dashboard',
  width: number = 1920,
  height: number = 1080
) {
  const el = document.getElementById(elementId)
  if (!el) {
    return () => {}
  }

  scale(el, width, height)

  const handleResize = () => scale(el, width, height)
  window.addEventListener('resize', handleResize)

  const interval = setInterval(() => {
    const { windowWidth, windowHeight } = getViewportDimensions()
    if (windowWidth !== vw || windowHeight !== vh) {
      scale(el, width, height)
    }
  }, 1000)

  return () => {
    window.removeEventListener('resize', handleResize)
    clearInterval(interval)
    el.style.transform = ''
    el.style.width = ''
    el.style.height = ''
  }
}
